import { Button, Grid } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { ICreateProps } from "../../../../utils/common-type";
import {
  generateFormItem,
  getTreeData,
  mapEnumToList,
} from "../../../../utils/helper";
import { CustomDialog } from "../../../common";
import { formInitialValues, ISuggestion, SuggestionTypeEnum } from "./type";

const Create = (props: ICreateProps<ISuggestion>) => {
  const { t } = useTranslation();
  const T = (name: string) => {
    return t(`Suggestion.${name}`);
  };
  return (
    <CustomDialog title={t("common.create")} {...props}>
      <Formik
        initialValues={formInitialValues}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateFormItem(
              form,
              [
                {
                  type: "text",
                  name: "playerID",
                  label: "playerID",
                  size: { xs: 12 },
                },
                {
                  type: "text",
                  name: "status",
                  label: "status",
                  size: { xs: 12 },
                },
                {
                  type: "text",
                  name: "suggestionID",
                  label: "suggestionID",
                  size: { xs: 12 },
                },
                {
                  type: "singleSelect",
                  name: "type",
                  label: "type",
                  treeData: getTreeData(
                    mapEnumToList(SuggestionTypeEnum),
                    false
                  ),
                  size: { xs: 12 },
                },
                {
                  type: "content",
                  name: "content",
                  label: "content",
                  size: { xs: 12 },
                  style: {
                    marginTop: 10,
                  },
                },
                {
                  type: "content",
                  name: "replay",
                  label: "replay",
                  size: { xs: 12 },
                  style: {
                    marginTop: 10,
                  },
                },
                {
                  type: "singleTime",
                  name: "createdAt",
                  label: "createdAt",
                  size: { xs: 12 },
                },
                {
                  type: "singleSelect",
                  name: "assignedUser",
                  label: "assignedUser",
                  size: { xs: 6 },
                  treeData: getTreeData(["無", "user1", "user2"], false),
                },
                {
                  type: "custom",
                  name: "readStatus",
                  label: "ReadStatus",
                  render: (
                    <Grid
                      container
                      item
                      xs={2}
                      justify="flex-start"
                      alignItems="flex-end"
                      key={"assignMeButton"}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          form.setFieldValue(
                            "assignedUser",
                            localStorage.getItem("username")
                          );
                        }}
                      >
                        {T("assignMe")}
                      </Button>
                    </Grid>
                  ),
                },
                {
                  type: "text",
                  name: "mark",
                  label: "mark",
                  size: { xs: 12 },
                },
              ],
              formInitialValues,
              T
            )}
          </Form>
        )}
      </Formik>
    </CustomDialog>
  );
};
export default Create;
